import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../core/animations';

/** Local file */

import { spekwo, spekWalk, spekwoType } from '../../../utils/index';

/**Service file */

import { SolutionFormService } from '../solutionForm.service';

@Component({
    selector: 'walk-call',
    templateUrl: './walkCallMain.component.html',
    styleUrls: ['./walkCallMain.component.scss'],
    animations: fuseAnimations,
})

export class WalkCallMainComponent {

    spekwoValues = spekwo;
    spekwoWalkValues = spekWalk;
    spekwoType = spekwoType;

    @Input()
    orderType: string;

    insId: string;
    insReportIdChangeSubscription: Subscription;

    constructor(
        private location: Location,
        private solutionFormService: SolutionFormService,
    ) {
    }

    ngOnInit() {
        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(data => {
                this.insId = data && data.insReportId;
            })
    }

    ngOnDestroy() {
        this.insReportIdChangeSubscription.unsubscribe();
    }
    
    goback() {
        this.location.back();
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/walk-call/walkCallMain.component.ts